<ng-container *ngIf="user">
  <ng-container *ngIf="user.formatted; else userFullName">{{ user.formatted }}</ng-container>
  <ng-template #userFullName>
    {{ !omitTitle ? user.title?.name : '' }} {{ user.firstName }} {{ user.lastName }}
  </ng-template>
</ng-container>
